module.exports = __webpack_public_path__ + "assets/img/business.c3de255d.png";